document.addEventListener("DOMContentLoaded", () => {
  const loadMoreBtn = document.querySelector(".blog-load-more");
  const articleList = document.querySelector(".blog--article-list");

  if (!loadMoreBtn || !articleList) return;

  const totalPages = parseInt(loadMoreBtn.dataset.totalPages, 10);
  const blogUrl = window.location.pathname;
  let currentPage = 1;

  loadMoreBtn.addEventListener("click", async () => {
    currentPage++;
    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = "Loading...";

    try {
      const response = await fetch(`${blogUrl}?page=${currentPage}`);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      const newArticles = doc.querySelectorAll(".blog--article-list > *");

      if (newArticles.length > 0) {
        newArticles.forEach((el) => {
          el.style.opacity = 0;
          articleList.appendChild(el);
          requestAnimationFrame(() => {
            el.style.transition = "opacity 0.4s ease";
            el.style.opacity = 1;
          });
        });
      }

      if (currentPage >= totalPages || newArticles.length === 0) {
        loadMoreBtn.remove();
      } else {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = "View More";
      }
    } catch (error) {
      console.error("Error loading more:", error);
      loadMoreBtn.textContent = "Error — Try Again";
      loadMoreBtn.disabled = false;
    }
  });
});
